'use client'

import { motion } from 'motion/react'
import type { PropsWithChildren } from 'react'
import { PageHeaderControls } from '../../../headers/page-header/page-header-controls.tsx'
import { PageHeaderMain } from '../../../headers/page-header/page-header-main.tsx'
import { PageHeaderOverlineBreadcrumbs } from '../../../headers/page-header/page-header-overline-breadcrumbs.tsx'
import { PageHeaderOverlineDivider } from '../../../headers/page-header/page-header-overline-divider.tsx'
import { PageHeaderOverlineLink } from '../../../headers/page-header/page-header-overline-link.tsx'
import { PageHeaderOverline } from '../../../headers/page-header/page-header-overline.tsx'
import { PageHeaderSubtitle } from '../../../headers/page-header/page-header-subtitle.tsx'
import { PageHeaderTitleBreadcrumbs } from '../../../headers/page-header/page-header-title-breadcrumbs.tsx'
import {
  PageHeader,
  type PageHeaderProps,
} from '../../../headers/page-header/page-header.tsx'
import { modalHeaderVariants } from '../../utils.ts'
import { ModalOverlineHeaderTitle } from './modal-overline-header-title.tsx'

export type ModalOverlineHeaderProps = PropsWithChildren<PageHeaderProps>

export const ModalOverlineHeaderComponent = ({
  children,
  ...props
}: ModalOverlineHeaderProps) => {
  return (
    <motion.div
      initial={modalHeaderVariants.initial}
      animate={modalHeaderVariants.open}
      exit={modalHeaderVariants.initial}
    >
      <PageHeader {...props}>{children}</PageHeader>
    </motion.div>
  )
}

const ModalOverlineHeaderNamespace = Object.assign(
  ModalOverlineHeaderComponent,
  {
    Title: ModalOverlineHeaderTitle,
    OverlineBreadcrumbs: PageHeaderOverlineBreadcrumbs,
    OverlineDivider: PageHeaderOverlineDivider,
    OverlineLink: PageHeaderOverlineLink,
    Subtitle: PageHeaderSubtitle,
    TitleBreadcrumbs: PageHeaderTitleBreadcrumbs,
    Main: PageHeaderMain,
    Overline: PageHeaderOverline,
    Controls: PageHeaderControls,
  }
)

export { ModalOverlineHeaderNamespace as ModalOverlineHeader }
